import { swalWithConfirmAndCancelButtons } from "components/custom/swal"
import download from "downloadjs"
import moment from "moment"
import React, { useEffect, useRef, useState } from "react"
import Loader from "react-loaders"
import { toast } from "react-toastify"
import { Col, Input, Label, Modal, Row } from "reactstrap"
import api from "services/api.service"
import { userService } from "services/user.service"
import colors from "utils/colors"
import GeneralNeedSectionViewOnly from "../ViewOnly/GeneralNeedSectionViewOnly"
import generatePDF, { Margin } from "react-to-pdf"
import OccApproachSectionViewOnly from "../ViewOnly/OccApproachSectionViewOnly"
import ContractSectionViewOnly from "../ViewOnly/ContractSectionViewOnly"
import ForecastSectionViewOnly from "../ViewOnly/ForecastSectionViewOnly"
import GovernanceSectionViewOnly from "../ViewOnly/GovernanceSectionViewOnly"
import LookbackSection from "../LookbackSection"
import ResultSection from "../ResultSection"
import NoteDrawer from "../Drawer/NoteDrawer"
import DocumentDrawer from "../Drawer/DocumentDrawer"
import Breadcrumb from "components/Common/Breadcrumb"
import LocationSection from "../LocationSection"

const BusinessCaseReportModal = ({
  isOpen,
  toggleModal,
  alternative, //either alternative
  scenarioId, //or scenarioId
  onSave, // optional
}) => {
  const currentUser = userService.getLoggedInUser()
  const [isLoading, setIsLoading] = useState(false)
  const [isDownloading, setIsDownloading] = useState(false)
  const [options, setOptions] = useState([])

  useEffect(() => {
    if (isOpen) {
      loadData()
    }
  }, [isOpen])

  const loadData = async () => {
    setIsLoading(true)

    let data = {}
    if (scenarioId == undefined) {
      data = await api.getBcReportOptions(
        alternative.alternativeID,
        currentUser.userID
      )
    } else {
      data = await api.getBcReportScenarioOptions(
        scenarioId,
        currentUser.userID
      )
    }
    setOptions(data)
    setIsLoading(false)
  }

  const save = async () => {
    setIsDownloading(true)

    if (onSave) {
      await onSave(options, () => setIsDownloading(false))
    } else {
      let formTabs = options.filter(x => x.orderID > 0)
      if (formTabs.length > 0) {
        let tasks = formTabs.map(t => async () => {
          let imageNameToSave = `${alternative.businessCaseID}_${t.listItemID}`
          return await api.generateTabsImage(
            alternative.alternativeID,
            imageNameToSave,
            [t]
          )
        })
        await Promise.all(tasks.map(task => task()))
      }

      api
        .getBusinessCaseReport(
          currentUser.userID,
          alternative.businessCaseID,
          options
        )
        .then(
          blob => {
            setIsDownloading(false)
            download(
              blob,
              `${alternative.alternativeNum} - ${alternative.alternativeName} - Business Case Report.pdf`
            )
          },
          err => setIsDownloading(false)
        )
    }
  }

  return (
    <Modal
      backdrop="static"
      isOpen={isOpen}
      size="md"
      toggle={() => {
        toggleModal()
      }}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myModalLabel">
          Business Case Report
        </h5>
        <button
          type="button"
          onClick={() => {
            toggleModal()
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      {isLoading && (
        <Loader
          type="line-scale-pulse-out"
          color={colors.primary}
          style={{ textAlign: "center" }}
        />
      )}
      {!isLoading && (
        <div className="modal-body">
          {options.map((o, idx) => (
            <div className="mb-3" key={idx}>
              <Input
                id={o.listItemName}
                type="checkbox"
                style={{ marginLeft: "10px" }}
                checked={o.completed}
                onClick={() => {
                  let copy = [...options]
                  let item = copy.find(x => x.listItemName == o.listItemName)
                  item.completed = !item.completed
                  setOptions(copy)
                }}
              />
              <Label
                className="form-check-label"
                for={o.listItemName}
                style={{ marginLeft: "10px" }}
              >
                {o.listItemName}
              </Label>
            </div>
          ))}
        </div>
      )}

      <div
        className="modal-footer"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={toggleModal}
        >
          Close
        </button>
        {isDownloading && (
          <Loader
            type="line-scale-pulse-out"
            color={colors.primary}
            style={{ textAlign: "center" }}
          />
        )}
        <div className="d-flex-row ai-center">
          <button
            type="button"
            className="btn btn-primary save-user"
            onClick={save}
            disabled={isDownloading}
          >
            Run Report
          </button>
          {/* {openReportPDFViewModal != undefined && (
            <button
              type="button"
              className="btn btn-primary save-user"
              onClick={() => openReportPDFViewModal(options)}
            >
              Run PDF Report
            </button>
          )} */}
          {/* <button
              type="button"
              className="btn btn-primary save-user"
              onClick={getPdfReport}
            >
              Run PDF Report
            </button> */}
        </div>
      </div>
    </Modal>
  )
}

export const BusinessCaseReportPDFViewModal = ({
  reportPDFViewModalOptions,

  isOpen,
  toggleModal,

  alternative,
  enterprise,
  scenario,
  fieldConfigItems,
  entities,

  sbuLabel,
  governanceBoardLabel,
  systemRetirementsLabel,
  brmLabel,
  advancedPlanningLabel,
  investmentCategoryLabel,
  lbrLabel,
  planningCategoryLabel,
  ldoLabel,
  planningStageLabel,

  governanceOptions,
  sponsoringOptions,
  priorityOptions,
}) => {
  const [isExporting, setIsExporting] = useState(false)
  const containerRef = useRef()

  useEffect(() => {
    if (isOpen) {
      console.log(reportPDFViewModalOptions)
      setIsExporting(false)
    }
  }, isOpen)

  const exportPageToPdf = () => {
    setIsExporting(true)

    const el = containerRef.current
    const originalHeight = el.style.height
    const originalOverflow = el.style.overflow
    // Expand for export
    el.style.height = "auto"
    el.style.overflow = "visible"

    setTimeout(() => {
      // html2pdf()
      //   .set({
      //     margin: 0.5,
      //     filename: "my-document.pdf",
      //     image: { type: "png", quality: 1 },
      //     html2canvas: { scale: 1, useCORS: true, allowTaint: false },
      //     jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      //     pagebreak: { mode: ["css", "legacy"] },
      //   })
      //   .from(el)
      //   .save()
      // el.style.height = originalHeight
      // el.style.overflow = originalOverflow
      // setIsExporting(false)

      // var opt = {
      //   margin: 0,
      //   filename: "time_sheet_report.pdf",
      //   image: { type: "jpeg", quality: 0.2 },
      //   html2canvas: { scale: 1, useCORS: true },
      //   jsPDF: { unit: "in", format: "a4", orientation: "p" },
      // }

      // html2pdf().set(opt).from(el).save()

      // generatePDF(containerRef, {
      //   filename: `BusinessCaseReport.pdf`,
      //   page: {
      //     margin: Margin.MEDIUM,
      //     format: "A4",
      //     orientation: "landscape",
      //   },
      // }).then(() => {
      //   el.style.height = originalHeight
      //   el.style.overflow = originalOverflow
      //   setIsExporting(false)
      // })
    }, 100)
  }

  return (
    <Modal
      backdrop="static"
      isOpen={isOpen}
      fullscreen={true}
      toggle={() => {
        toggleModal()
      }}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myModalLabel">
          Business Case Report View
        </h5>
        <button
          type="button"
          onClick={() => {
            toggleModal()
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div>
        <button
          className="btn btn-primary"
          onClick={exportPageToPdf}
          disabled={isExporting}
          style={{
            float: "right",
            marginRight: "20px",
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          Export to PDF
        </button>
      </div>
      <div className="modal-body" ref={containerRef}>
        {reportPDFViewModalOptions
          .filter(x => x.completed)
          .map((t, idx) => {
            if (t.listItemID == "General_Need") {
              return (
                <>
                  <Breadcrumb title={t.listItemName} />
                  <GeneralNeedSectionViewOnly
                    key={idx}
                    alternative={alternative}
                    governanceOptions={governanceOptions}
                    sponsoringOptions={sponsoringOptions}
                    priorityOptions={priorityOptions}
                    fieldConfigItems={fieldConfigItems}
                    entities={entities}
                    formId={t.orderID}
                    sbuLabel={sbuLabel}
                    governanceBoardLabel={governanceBoardLabel}
                    enterprise={enterprise}
                  />
                </>
              )
            } else if (t.listItemID == "OCC_Approach") {
              return (
                <>
                  <Breadcrumb title={t.listItemName} />
                  <OccApproachSectionViewOnly
                    key={idx}
                    alternative={alternative}
                    scenario={scenario}
                    sectionFormId={t.orderID}
                    systemRetirementsLabel={systemRetirementsLabel}
                  />
                </>
              )
            } else if (t.listItemID == "Contract") {
              return (
                <>
                  <Breadcrumb title={t.listItemName} />
                  <ContractSectionViewOnly
                    key={idx}
                    alternative={alternative}
                    alternativeId={alternative.alternativeID}
                    scenario={scenario}
                    enterprise={enterprise}
                  />
                </>
              )
            } else if (t.listItemID == "Forecast") {
              return (
                <>
                  <Breadcrumb title={t.listItemName} />
                  <ForecastSectionViewOnly
                    key={idx}
                    alternative={alternative}
                    alternativeId={alternative.alternativeID}
                    scenario={scenario}
                  />
                </>
              )
            } else if (t.listItemID == "Governance") {
              return (
                <>
                  <Breadcrumb title={t.listItemName} />
                  <GovernanceSectionViewOnly
                    key={idx}
                    alternative={alternative}
                    alternativeId={alternative.alternativeID}
                    scenario={scenario}
                    fieldConfigItems={fieldConfigItems}
                    sectionFormId={t.orderID}
                    brmLabel={brmLabel}
                    advancedPlanningLabel={advancedPlanningLabel}
                    investmentCategoryLabel={investmentCategoryLabel}
                    lbrLabel={lbrLabel}
                    planningCategoryLabel={planningCategoryLabel}
                    ldoLabel={ldoLabel}
                    planningStageLabel={planningStageLabel}
                  />
                </>
              )
            } else if (t.listItemID == "Documents") {
              return (
                <>
                  <Breadcrumb title={t.listItemName} />
                  <DocumentDrawer
                    key={idx}
                    alternative={alternative}
                    activeDrawer={"Document"}
                    hideActionButtons={true}
                  />
                </>
              )
            } else if (t.listItemID == "Notes") {
              return (
                <>
                  <Breadcrumb title={t.listItemName} />
                  <NoteDrawer
                    key={idx}
                    alternative={alternative}
                    activeDrawer={"Notes"}
                    hideActionButtons={true}
                  />
                </>
              )
            } else if (t.listItemID == "Location") {
              return (
                <>
                  <Breadcrumb title={t.listItemName} />
                  <LocationSection
                    key={idx}
                    enterprise={enterprise}
                    alternativeId={alternative.alternativeID}
                    scenarioId={alternative.scenarioID}
                    activeTab={"Location"}
                    sectionFormId={t.orderID}
                    hideActionButtons={true}
                    // showToastChangesCallback={showToastChangesCallback}
                    // triggerFormSave={triggerDynamicFormSave}
                    // setTriggerFormSave={setTriggerDynamicFormSave}
                  />
                </>
              )
            } else if (t.listItemID == "Lookback") {
              return (
                <>
                  <Breadcrumb title={t.listItemName} />
                  <LookbackSection
                    key={idx}
                    alternativeId={alternative.alternativeID}
                    businessCaseID={alternative.businessCaseID}
                    activeTab={"Lookback"}
                    scenario={scenario}
                    costChartId="costchart100"
                    benefitChartId="benefitchart100"
                    returnChartId="returnchart100"
                    roiChartId="roichart100"
                    irrChartId="irrchart100"
                    paybackChartId="paybackchart100"
                    timelineChartId="timelinechart100"
                    hideActionButtons={true}
                  />
                </>
              )
            } else if (t.listItemID == "Results") {
              return (
                <>
                  <Breadcrumb title={t.listItemName} />
                  <ResultSection
                    key={idx}
                    activeTab={"Results"}
                    alternativeId={alternative.alternativeID}
                    scenario={scenario}
                    costBenefitChartId="costbenefitchart1000"
                    costChartId="costchart1000"
                    benefitChartId="benefitchart1000"
                    returnChartId="returnchart1000"
                    paybackChartId="paybackchart1000"
                  />
                </>
              )
            }

            return null
          })}
      </div>
    </Modal>
  )
}

export default BusinessCaseReportModal
